import React from 'react';
import { Box, Dialog, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';

import logo from '@assets/plaidLogo.svg';
import exit from '@assets/exitIcon.svg';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './PayModal.json';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'SchnyderSLight',
  },
  content: {
    fontWeight: '400',
  },
}));

export const PayModal = ({ onClose, open }) => {
  const classes = useStyles();
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';

  return (
    <Dialog onClose={onClose} open={open}>
      <Grid container direction="row" justify="flex-end">
        <Box p={2} onClick={onClose} style={{ cursor: 'pointer' }}>
          <img src={exit} alt="exit" />
        </Box>
      </Grid>
      <Box p={5} pt={0}>
        <Box pb={6}>
          <Typography variant="h4" className={classes.title}>
            {l(content.title, language)}Plaid®
          </Typography>
        </Box>
        <Box pb={2}>
          <img src={logo} alt="logo" />
        </Box>
        <Typography variant="body2" className={classes.content}>
          {l(content.explain, language)}
        </Typography>
      </Box>
    </Dialog>
  );
};
